const get_started = {
    page_title: 'Bắt đầu',
    title: 'Vài điều giúp bạn thành công',
    subtitle: 'Một vài việc bạn có thể làm để nhanh chóng khai thác giá trị từ sdvico',
    develop: {
        title: 'Phát triển: Chỉ mất 5 phút để tích hợp ứng dụng của bạn',
        title_cloud: 'Phát triển: Tích hợp ứng dụng của bạn an toàn trong vài phút',
        subtitle_cloud: 'Hoặc chỉ mất 5 phút để tích hợp ứng dụng của bạn với các SDK và hướng dẫn có sẵn.',
        try_mcp: 'Thử tích hợp một lệnh với MCP',
    },
    customize: {
        title: 'Tùy chỉnh: Mang lại trải nghiệm đăng nhập tuyệt vời',
        preview: {
            title: 'Xem trước trực tiếp trải nghiệm đăng nhập bạn vừa tùy chỉnh',
            subtitle: 'Thử trải nghiệm đăng nhập của sdvico ngay để xem cách nó hoạt động',
        },
        connector: {
            title: 'Thêm nhiều bộ kết nối hơn để hỗ trợ thêm các phương thức đăng nhập xã hội',
            subtitle: 'Thử đăng nhập không cần mật khẩu và mang lại trải nghiệm an toàn, thuận tiện cho khách hàng của bạn',
        },
        continue_customizing: 'Tiếp tục tùy chỉnh',
        try_now: 'Thử ngay',
        add_more: 'Thêm nhiều hơn',
    },
    secure: {
        title: 'Bảo mật: Bảo vệ tài nguyên của bạn',
    },
    manage: {
        title: 'Quản lý: Xác định quyền truy cập cho sản phẩm và người dùng của bạn',
        rbac: {
            title: 'Thêm kiểm soát truy cập dựa trên vai trò để bảo vệ tài nguyên của bạn',
            subtitle: 'Kiểm soát tài nguyên của bạn thông qua phân quyền vai trò có khả năng mở rộng cho nhiều trường hợp sử dụng khác nhau.',
        },
        create_roles: 'Tạo vai trò',
    },
    convert_to_production: {
        card_title: 'Sẵn sàng vận hành thật? Đừng quên khởi động cấu hình production!',
        title: "Đừng để dự án của bạn mắc kẹt ở chế độ dev",
        subtitle: "Bạn đang dùng tenant dev để kiểm thử miễn phí. Để vận hành thật, hãy tạo hoặc chuyển đổi sang tenant production. Cần một giải pháp tùy chỉnh? <a>Liên hệ với chúng tôi</a>",
        convert_button: 'Chuyển sang tenant production',
    },
    oss_cloud: {
        try: {
            title: 'Bỏ qua công việc vận hành — thử sdvico Cloud miễn phí',
            badge: 'Đề xuất',
            description: 'Nhận một sdvico được quản lý toàn diện, không cần bảo trì — cùng với tích hợp nhanh nhờ MCP, hỗ trợ đa tenant, làm việc nhóm và mọi tính năng cao cấp. Bắt đầu miễn phí, không cần thẻ tín dụng.',
            action: 'Khám phá sdvico Cloud',
        },
        private_cloud: {
            title: 'Cần tuân thủ quy định hay triển khai tùy chỉnh?',
            card_title: 'Đám mây riêng',
            description: 'Nhận một instance sdvico riêng biệt với khả năng cách ly dữ liệu hoàn toàn, miền tùy chỉnh và bảo đảm SLA. Hoàn hảo cho doanh nghiệp có yêu cầu nghiêm ngặt về lưu trữ dữ liệu hoặc tuân thủ quy định. Chúng tôi xử lý hạ tầng để bạn tập trung vào sản phẩm của mình.',
        },
        sidebar: {
            title: 'Tập trung vào xây dựng, không phải vận hành hạ tầng.',
            description: 'Để sdvico Cloud xử lý hạ tầng xác thực cho bạn.',
            action: 'Thử sdvico Cloud',
        },
    },
    view_all: 'Xem tất cả →',
};
export default Object.freeze(get_started);
